"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/*
  The MIT License
  
  Copyright (c) 2017-2019 EclipseSource Munich
  https://github.com/eclipsesource/jsonforms
  
  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:
  
  The above copyright notice and this permission notice shall be included in
  all copies or substantial portions of the Software.
  
  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
  THE SOFTWARE.
*/
var react_1 = tslib_1.__importDefault(require("react"));
var merge_1 = tslib_1.__importDefault(require("lodash/merge"));
var core_1 = require("@jsonforms/core");
var react_2 = require("@jsonforms/react");
var core_2 = require("@material-ui/core");
var KeyboardArrowLeft_1 = tslib_1.__importDefault(require("@material-ui/icons/KeyboardArrowLeft"));
var KeyboardArrowRight_1 = tslib_1.__importDefault(require("@material-ui/icons/KeyboardArrowRight"));
var DateRange_1 = tslib_1.__importDefault(require("@material-ui/icons/DateRange"));
var Event_1 = tslib_1.__importDefault(require("@material-ui/icons/Event"));
var AccessTime_1 = tslib_1.__importDefault(require("@material-ui/icons/AccessTime"));
var pickers_1 = require("@material-ui/pickers");
var dayjs_1 = tslib_1.__importDefault(require("@date-io/dayjs"));
var util_1 = require("../util");
var MaterialDateTimeControl = /** @class */ (function (_super) {
    tslib_1.__extends(MaterialDateTimeControl, _super);
    function MaterialDateTimeControl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MaterialDateTimeControl.prototype.render = function () {
        var _a, _b;
        var _c = this.props, id = _c.id, description = _c.description, errors = _c.errors, label = _c.label, uischema = _c.uischema, visible = _c.visible, enabled = _c.enabled, required = _c.required, path = _c.path, handleChange = _c.handleChange, data = _c.data, config = _c.config;
        var appliedUiSchemaOptions = merge_1.default({}, config, uischema.options);
        var isValid = errors.length === 0;
        var showDescription = !core_1.isDescriptionHidden(visible, description, this.state.isFocused, appliedUiSchemaOptions.showUnfocusedDescription);
        var format = (_a = appliedUiSchemaOptions.dateTimeFormat) !== null && _a !== void 0 ? _a : 'YYYY-MM-DD HH:mm';
        var saveFormat = (_b = appliedUiSchemaOptions.dateTimeSaveFormat) !== null && _b !== void 0 ? _b : undefined;
        var firstFormHelperText = showDescription
            ? description
            : !isValid
                ? errors
                : null;
        var secondFormHelperText = showDescription && !isValid ? errors : null;
        return (react_1.default.createElement(core_2.Hidden, { xsUp: !visible },
            react_1.default.createElement(pickers_1.MuiPickersUtilsProvider, { utils: dayjs_1.default },
                react_1.default.createElement(pickers_1.KeyboardDateTimePicker, { id: id + '-input', required: required && !appliedUiSchemaOptions.hideRequiredAsterisk, label: label, error: !isValid, fullWidth: !appliedUiSchemaOptions.trim, onFocus: this.onFocus, onBlur: this.onBlur, InputLabelProps: data ? { shrink: true } : undefined, value: util_1.getData(data, saveFormat), clearable: true, onChange: util_1.createOnChangeHandler(path, handleChange, saveFormat), format: format, ampm: !!appliedUiSchemaOptions.ampm, views: appliedUiSchemaOptions.views, disabled: !enabled, autoFocus: appliedUiSchemaOptions.focus, cancelLabel: appliedUiSchemaOptions.cancelLabel, clearLabel: appliedUiSchemaOptions.clearLabel, okLabel: appliedUiSchemaOptions.okLabel, leftArrowIcon: react_1.default.createElement(KeyboardArrowLeft_1.default, null), rightArrowIcon: react_1.default.createElement(KeyboardArrowRight_1.default, null), dateRangeIcon: react_1.default.createElement(DateRange_1.default, null), keyboardIcon: react_1.default.createElement(Event_1.default, null), timeIcon: react_1.default.createElement(AccessTime_1.default, null), invalidDateMessage: null, maxDateMessage: null, minDateMessage: null }),
                react_1.default.createElement(core_2.FormHelperText, { error: !isValid && !showDescription }, firstFormHelperText),
                react_1.default.createElement(core_2.FormHelperText, { error: !isValid }, secondFormHelperText))));
    };
    return MaterialDateTimeControl;
}(react_2.Control));
exports.MaterialDateTimeControl = MaterialDateTimeControl;
exports.materialDateTimeControlTester = core_1.rankWith(2, core_1.isDateTimeControl);
exports.default = react_2.withJsonFormsControlProps(MaterialDateTimeControl);
//# sourceMappingURL=MaterialDateTimeControl.js.map